var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapScreenshotPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 104,
    viewBox: "0 0 72 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M36.0778 0C9.33045 0 1.24406 18.2619 0 30.4881C0 33.8929 0.155508 35.2857 2.64363 35.2857H18.1944C21.9266 35.2857 22.5486 32.9643 23.0151 30.4881C24.1037 26.3095 28.3024 20.7381 36.2333 20.7381C41.987 20.7381 46.9633 24.2976 46.9633 29.25C46.9633 36.369 37.3218 38.0714 31.879 43.6429C26.2808 49.369 23.6371 55.4048 23.6371 66.3929C23.6371 69.4881 24.5702 71.3452 28.6134 71.3452H41.5205C45.5637 71.3452 46.4968 70.1071 46.4968 66.3929C46.4968 57.5714 53.0281 53.0833 58.4708 49.369C64.3801 45.1905 72 39.1548 72 28.3214C72 8.82144 54.4276 0 36.0778 0ZM43.2311 77.8452H25.9698C23.1706 77.8452 21.46 78.7738 21.46 82.3333V99.5119C21.46 103.071 23.1706 104 25.9698 104H43.2311C46.0302 104 47.7408 103.071 47.7408 99.5119V82.3333C47.7408 78.7738 46.0302 77.8452 43.2311 77.8452Z",
    fill: "#71828C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapScreenshotPlaceholder);
export default __webpack_public_path__ + "static/media/map_screenshot_placeholder.adc09f283756c3b435762872e9dc3268.svg";
export { ForwardRef as ReactComponent };